$(document).ready(function () {
  $('.roomvo-launch-link').on('click',function() {
    // console.log('clicky');
    // window.location.href = 'https://www.greenbuildingsupply.com/blogs/learn/roomvo-room-visualizer';
  });
  // -------------------------------------------------------------------------------
  // ------------------------------- GENERAL ONLOAD STUFF --------------------------
  // -------------------------------------------------------------------------------
  // Check if there is a hash in the URL
  if (window.location.hash.indexOf("#desktop") > -1) {
    // Remove the hash by updating the URL without reloading the page
    history.replaceState(null, null, window.location.pathname);
    //  console.log('Removed #desktop-1 from URL');
  }

  const numberFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // nav menu
  $('[id^="Details-HeaderMenu-"]')
    .on("mouseover", function () {
      $(this).attr("open", true);
    })
    .on("mouseout", function () {
      $(this).attr("open", false);
    });

  //update pagination links to include url filter params
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.delete("page");
  $(".pagination__item").each(function () {
    var newURL = $(this).attr("href") + "&" + searchParams;
    $(this).attr("href", newURL);
  });

  $(".collection-list__item").on("click", function () {
    $(this).find("a").trigger("click");
  });

  // for product cards with swatches. on hovering the swatch, change the main image to match it
  $(".swatch-link img").on("mouseover", function () {
    var variantID = $(this).attr("variant-id");
    var productID = $(this).attr("product-id");
    var thisMedia = $(".media[product-id=" + productID + "]");
    thisMedia.children(".swatch-main-image").each(function () {
      if ($(this).attr("variant-id") == variantID) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(".slider-button").attr("data-step", 1);
  }



  // -------------------------------------------------------------------------------
  // ------------------------------- PRODUCT PAGE STUFF ----------------------------
  // -------------------------------------------------------------------------------

  // Find the current color and make sure thumbnails are not showing that shouldnt
  var selectedOption = $("fieldset[primary-option] input:checked").attr(
    "value"
  );
  var selectedColor = $('input[name="Color"]:checked').attr("value");
  var thumbnailCount = 0;

  // Match thumbnail alt text on variant names, to determine for which variants each thumbnail displays
  // Liquid cannot do regex so js has to do this
  $(".thumbnail").each(function () {
    var thisSrc = $(this).find('img').attr('src');
    var srcRegex = new RegExp("_skus([0-9-]+)",'g');
    const skuMatches = thisSrc.matchAll(srcRegex);
    var thisSkuList = "";
    for (const match of skuMatches) {
      thisSkuList = thisSkuList + match[1];
    }
    
    var thisAlt = $(this).find("img").attr("alt") || ""; // Handle undefined alt text
    // var thisVariantIDList = "";
    // var aria_current = $(this).attr("aria-current")
    //   ? $(this).attr("aria-current").trim()
    //   : "false";
    // var mainProductImage = $(this).attr("main-product-image") === "true"; // check if this is an image for a standalone product
    // var isCurrent = aria_current === "true";
    // var thumbnailMediaId = $(this).attr("thumbnail-media-id");

    // (PIN) in the alt text means display this image for all variants
    if (thisAlt.includes("(PIN)")) {
      $(this).parent().attr("data-sku", "all");
      $(this).parent().show();
      thumbnailCount++;
      return; // Skip further checks for this image
    }

    
    $(this).parent().attr("data-sku", thisSkuList);

  });

  $('.video-thumbnail').each(function() {
    var thisSkuList = '';
    var thisAlt = $(this).find("img").attr("alt") || "";
    // set this thumbnail's variant id attribute which we will use later to show or hide it based on the selected variant
    $(".pricing-list").each(function () {
      var variantID = $(this).attr("variant-id");
      var variantSku = $(this).attr('variant-sku').split('#')[1];
      var optionName = $(this).attr("variant-option1");
      var thisOptionRegex = new RegExp(
        "(^|,| and )" + RegExp.escape(optionName) + "($|,| and )",
        "i"
      );

      if (
        thisOptionRegex.test(thisAlt) ||
        optionName == "Default Title" 
      ) {
        thisSkuList = thisSkuList + variantSku;
      }
    });

    $(this).parent().attr("data-sku", thisSkuList);
  });

  checkSale();

  // -------------------------------- PRODUCT PAGE EXPAND/COLLAPSE CONTENT----------------------------------

  var selectedVariant = $(".selected-product-variant").attr("value");
  $("#tabs .des-content").each(function () {
    var contentWrapper = $(this);
    var contentHeight = contentWrapper.height();

    if (contentHeight > 500) {
      // var initialContent = contentWrapper.html();
      // contentWrapper.data('initialContent', initialContent);
      contentWrapper.css("max-height", "500px").css("overflow", "hidden"); // Ensure content is hidden initially
      var expandButton = $("<button>")
        .addClass("expand-button collapsed")
        .text("Expand Details");
      var expandWrapper = $("<div>")
        .addClass("expand-wrapper")
        .append(expandButton);
      contentWrapper.after(expandWrapper);

      $(".pro-spec + div .expand-button").text("Expand Specs");
    }
  });

  $(document).on("click", "#tabs .expand-button", function (event) {
    var contentWrapper = $(this)
      .closest(".expand-wrapper")
      .prev(".des-content");
    console.log(contentWrapper.attr("style"));
    // var initialContent = contentWrapper.data('initialContent');
    var button = $(this);

    if (button.hasClass("collapsed")) {
      button.removeClass("collapsed").text("Collapse Details");
      // contentWrapper.addClass('expanded').css('max-height', 'none').css('overflow', 'visible').html(initialContent);
      contentWrapper
        .addClass("expanded")
        .css("max-height", "none")
        .css("overflow", "visible");
      $(".pro-spec.expanded + div .expand-button").text("Collapse Specs");
    } else {
      button.addClass("collapsed").text("Expand Details");
      // contentWrapper.removeClass('expanded').css('max-height', '500px').css('overflow', 'hidden').html(initialContent);
      contentWrapper
        .removeClass("expanded")
        .css("max-height", "500px")
        .css("overflow", "hidden");
      $(".pro-spec + div .expand-button").text("Expand Specs");
    }
  });

  // ------------------------- PRODUCT ON-SALE STUFF--------------------------------

  function checkSale() {
    console.log('checkSale');
    var selectedOption1 = "";
    var selectedOption2 = "";
    var selectedOption3 = "";

    var selectedSize = $('input[name="Size"]:checked').val();
    var selectedOption1 = $("fieldset[primary-option] input:checked").val();
    if ($("fieldset[secondary-option] input:checked").length > 0) {
      var selectedOption2 = $("fieldset[secondary-option] input:checked").val();
    }
    if ($("fieldset[tertiary-option] input:checked").length > 0) {
      var selectedOption3 = $("fieldset[tertiary-option] input:checked").val();
    }

    // Iterate over each color input to validate if the combination is valid
    $("label[variant-id]").removeClass("sale-badge-before");
    $("label[variant-id]")
      .find(".popup_data")
      .find(".product-link")
      .find(".badge")
      .hide();

    $("fieldset[primary-option] > input").each(function () {
      var firstOption = $(this).val();
      var dynamicCombinedOption = firstOption;
      if (selectedOption2.length > 0) {
        dynamicCombinedOption = dynamicCombinedOption + " / " + selectedOption2;
      }
      if (selectedOption3.length > 0) {
        dynamicCombinedOption = dynamicCombinedOption + " / " + selectedOption3;
      }

      var thisVariant = this.getAttribute("variant-id");
      var selectedVariant = $(".selected-product-variant").attr("value");
      // console.log('dynamicCombinedOption is '+dynamicCombinedOption);
      // Check if the dynamic combination exists in the list of all potential options

      if ($("#on-sale-variants").text().indexOf(dynamicCombinedOption) > -1) {
        // we need to find all related thumbnails, images and references and add a sale badge
        $('label[variant-name="' + firstOption + '"]').addClass(
          "sale-badge-before"
        );
        $('label[variant-name="' + firstOption + '"]')
          .find(".badge")
          .show();
      } else {
        $('label[variant-name="${firstOption}"]').removeClass(
          "sale-badge-before"
        );
        $('label[variant-name="${firstOption}"]')
          .find(".popup_data")
          .find(".product-link")
          .find(".badge")
          .hide();
        $(".thumbnail-list__item:not(.deks-thumbnail-active)").each(
          function () {
            // $(this).find('.badge').addClass('hide-badge');
          }
        );
      }
    });
  }

  // ----------------------------- PRODUCT MEDIA GALLERY ------------------------------------

  $("body").on(
    "click",
    ".fancybox-container .custom-fancy-button",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Get the Fancybox instance
      var fancyboxInstance = $.fancybox.getInstance();
      if (!fancyboxInstance) return;
      var originalTotal = parseInt($("span[data-fancybox-count]").text());
      var currentIndex = parseInt($("span[data-fancybox-index]").text()) - 1; // Current index within Fancybox

      var totalIndex = originalTotal; // Total slides in Fancybox
      var buttonClass = $(this).attr("class"); // Button class to determine direction
      var newIndex = currentIndex; // Initialize newIndex

      // Determine new index based on button direction
      if (buttonClass.includes("right")) {
        if (currentIndex + 1 === originalTotal) {
          newIndex = 0;
        } else {
          newIndex = currentIndex + 1;
        }
      } else {
        if (currentIndex === 0) {
          newIndex = originalTotal - 1;
        } else {
          newIndex = currentIndex - 1;
        }
      }
      // console.log('my new index is ' + newIndex);
      // Get the new thumbnail element and find the associated large image
      var $thumbnail = $(".deks-thumbnail-active").eq(newIndex);
      var targetId = $thumbnail.attr("data-target"); // Get the target ID for the large image
      console.log("targetID " + targetId);
      // Find the corresponding large image container using the target ID
      var $largeImageContainer = $('li[data-media-id="' + targetId + '"]');
      var newImgSrc = $largeImageContainer.attr("data-src"); // Get the large image source from data-src attribute

      if (!newImgSrc) {
        console.error("Large image source not found for index:", newIndex);
        return;
      }
      // console.log('New large image source:', newImgSrc);

      // Use Fancybox to navigate to the new index
      //  fancyboxInstance.jumpTo(newIndex);

      // Update the image in the current Fancybox slide to the new large image source
      var $image = fancyboxInstance.current.$content.find(".fancybox-image");
      $image.attr("src", newImgSrc);

      // Wait for the image to load to get its intrinsic dimensions
      $image.on("load", function () {
        // Get the natural dimensions of the image
        var naturalWidth = this.naturalWidth;
        var naturalHeight = this.naturalHeight;

        // Update the Fancybox content size
        fancyboxInstance.current.$content.css({
          width: naturalWidth + "px",
          height: naturalHeight + "px",
          transform: "translate(-50%, -50%)",
        });

        // Update Fancybox's internal width and height properties
        fancyboxInstance.current.width = naturalWidth;
        fancyboxInstance.current.height = naturalHeight;

        // Trigger a recalculation of Fancybox layout
        fancyboxInstance.update();
      });

      // Update indices displayed
      $(this)
        .parent()
        .parent()
        .parent()
        .find("span[data-fancybox-index]")
        .text(newIndex + 1);
      $("span[data-fancybox-count]").text(originalTotal);
    }
  );

  $("body").on("click", ".product__media-zoom-lightbox", function () {
    // first we count total relevant thumbnails and replace that in the index
    var thumbnailCount = 0;
    var activeIndex;
    $(".thumbnail-list__item").each(function () {
      var display = $(this).css("display");
      if (display === "none") {
        // we dont count nones
      } else {
        thumbnailCount++;
        var aria_current = $(this).find("button").attr("aria-current");
        if (aria_current === "true") {
          activeIndex = thumbnailCount;
        }
      }
    });
    // we also need to find the relevant index of this so we can replace the first number as well

    setTimeout(function () {
      $("span[data-fancybox-index]").text(activeIndex);
      $("span[data-fancybox-count]").text(thumbnailCount);
      $(".fancybox-navigation").append(
        '<button class="fancybox-button fancybox-button--arrow_left custom-fancy-button"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg></div></button><button class="fancybox-button fancybox-button--arrow_right custom-fancy-button"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg></div></button>'
      );
    }, 50);
  });

  var template = $("product-info").attr("template-type").split("|");

  // ------------------------------------- ON CHANGE PRODUCT VARIANT --------------------------------------

  $("body").on("change", ".selected-product-variant", function () {
    var selectedVariant = $(this).attr("value"); //shopify variant id
    var selectedVariantSku = $('.selected-product-sku').attr('value'); // sku
    var thisVar = $(this);

    let selectedOptions = new Map();
    $("fieldset.product-form__input:not(.custom)").each(function (index) {
      selected = $(this).find("input:checked").val();
      selectedOptions.set(index, selected);
    });

    $(
      ".thumbnail-list__item[data-variant-id=" + selectedVariant + "]"
    ).addClass("deks-thumbnail-active");
    $(
      ".thumbnail-list__item:not([data-variant-id=" + selectedVariant + "])"
    ).removeClass("deks-thumbnail-active");

    // console.log(selectedOptions);
    //make a string representation of the currently selected options
    combinedSelectedOptions = [...selectedOptions.values()].join(" / ");
    //for quote requests, set hidden input to option values so they get passed to the email
    $('input[name="contact[product-options]"').attr(
      "value",
      combinedSelectedOptions
    );

    if (combinedSelectedOptions.length == 0) {
      combinedSelectedOptions = "Default Title";
    }
    // console.log('selectedVariant is '+selectedVariant);
    // console.log('combinedSelectedOptions ' + combinedSelectedOptions);
    $(".specs").hide();
    $('.specs[name="' + selectedVariant + '"]').show();

    var thumbnailCount = 0;
    // Show or hide thumbnails on whether they match variant ids
    $(".thumbnail-list__item[data-sku*=" + selectedVariantSku + "]").each(
      function () {
        $(this).show();
        thumbnailCount++;
      }
    );

    $(".thumbnail-list__item")
      .not("[data-sku*=" + selectedVariantSku + "]")
      .each(function () {
        $(this).hide();
      });

    $(".thumbnail-list__item[data-sku='all']").each(function () {
      $(this).show();
      thumbnailCount++;
    });

    // if there are more than 5 active thumbnails, show the right arrow button
    if (thumbnailCount > 5) {
      $(".slider-button--next").removeAttr("disabled");
      $(".slider-button--next").show();
      $(".slider-button--prev").trigger("click");
    } else {
      $(".slider-button--next").hide();
      $(".slider-button--next").attr("disabled", "disabled");
    }

    const mainImage = $(".product__media-item.variant-main-image.is-active")
      .find("img")
      .attr("src");

    $(".main-product-card_for_accessory-products").find('img').attr("srcset", mainImage);

    var selected_variant_sku = "";
    var combined_options = "";
    // console.log('my selected variant is ' + selectedVariant);
    $(".pricing-list").each(function () {
      var variant_id = $(this).attr("variant-id");
      if (variant_id === selectedVariant) {
        // console.log('found a match');
        var sample_id = $(this).attr("variant-sample");
        var variant_sku = $(this).attr("variant-SKU");
        var variant_model = $(this).attr("variant-vendor-item");
        var price_per_sqft = $(this).attr("variant-price-per-sqft");
        var sqft = $(this).attr("data-sq-ft");
        var regular_price = $(this).attr("variant-price");
        var was_price = $(this).attr("variant-compare-price");
        var save_price = $(this).attr("variant-savings");
        var option1 = $(this).attr("variant-option1");
        var option2 = $(this).attr("variant-option2");
        var option3 = $(this).attr("variant-option3");

        var selectedOption = $("fieldset[primary-option] input:checked").val();
        var selectedColor = $('input[name="Color"]:checked').val();
        var shippingMessage = $(this).attr("shipping-message");
        combined_options = $(this).attr("variant-title");
        var getAltText = $(".product__media.media")
          .find("img")
          .attr("alt")
          .trim()
          .replace("(PIN)", "");
        var saleText = $(this).attr("sale-message");
        var productTitle = $("h1").text().trim();
        var backend = $(this).attr("backend-order");
        var backend_message = $(this).attr("backend-message");
        var backend_date = $(this).attr("backend-date");
        var todaysDate = $(this).attr("currentDate");
        var saleTruth = $(this).attr("sale-truth");
        // Convert the date strings to Date objects
        var backendDateObj = new Date(backend_date);
        var todaysDateObj = new Date(todaysDate);

        if (variant_id == selectedVariant) {
          selected_variant_sku = variant_sku.split("#")[1];
        }
        // console.log('my altText is ' + getAltText + ' and my title is ' + productTitle);

        //with custom paint, the alt text should only be set by the color selection which is handled in product-variant-picker
        if (!template.includes("Custom Paint")) {
          // if (getAltText.replace(/\s+/g, ' ') === productTitle.replace(/\s+/g, ' ')) {
          //     $('.colorSelectedSlideText').text(selectedColor);
          // } else {
          //   $('.colorSelectedSlideText').text(getAltText);
          // }

          // Find the current primary option
          var selectedOption = $("fieldset[primary-option] input:checked").attr(
            "value"
          );

          var selectedOptionInput = $(
            "fieldset[primary-option] input:checked"
          ).attr("id");
          // Build a regex pattern to match the selected color as a standalone word or with specific conditions
          var optionRegex = new RegExp(
            "(^|\\s|,| and )" + selectedOption + "(\\s|$|,| and )",
            "i"
          );
          var selectedOption_onsale = $(
            'label[for="' + selectedOptionInput + '"]'
          )
            .find(".badge")
            .css("display");
        } else {
          // if this is a Custom Paint item,
          // and Untinted is selected, allow adding to cart without selecting color

          if ($('input[value="Untinted"]:checked').length > 0) {
            $(".button--primary").removeAttr("disabled");
            $(".button--primary > span").text("Add to Cart");
            $(".button--primary > b").text("Add a Sample to Cart");
            $(".paint-custom-color").val("Untinted");
            $(".custom-paint_fieldset").addClass("disabled-fieldset");
          } else {
            //if Untinted is not selected then allow choosing color and disabled add to cart button until color has been selected
            $(".custom-paint_fieldset").removeClass("disabled-fieldset");
            if (
              $(".paint-custom-color").val() == "none" ||
              $(".paint-custom-color").val() == "Untinted"
            ) {
              $(".button--primary").attr("disabled", "disabled");
              $(".button--primary > span").text("Select a color");
              $(".button--primary > b").text("Select a color");
            }
            if ($(".paint-custom-color").attr("sample") == "untinted") {
              $("#sample-ProductSubmitButton > b").text(
                "Add Untinted Sample to Cart"
              );
              $("#sample-ProductSubmitButton1 > b").text(
                "Add Untinted Sample to Cart"
              );
              $("#sample-ProductSubmitButton").removeAttr("disabled");
              $("#sample-ProductSubmitButton1").removeAttr("disabled");
            }
          }
        }

        //update price

        var split_price = regular_price.split("$")[1];
        var formatted_price =
          "$<span class='whole-number'>" +
          split_price.split(".")[0] +
          "</span>." +
          split_price.split(".")[1];
        $(this).parent().find("#final-price").html(formatted_price);
        $(".main-product-card_for_accessory-products")
          .find(".now-price")
          .html(formatted_price);
        $(this).addClass("active");
        var lengthPricePer = $(this)
          .parent()
          .parent()
          .find("#pricePerUnit").length;

        if (lengthPricePer > 0) {
          var split_price = price_per_sqft.split("$")[1];
          var formatted_price =
            "$<span class='whole-number'>" +
            split_price.split(".")[0] +
            "</span>." +
            split_price.split(".")[1];
          var price_per_unit = $(this).attr("variant-price").split("$")[1];
          var formatted_price_per_unit =
            "$<span class='whole-number'>" +
            price_per_unit.split(".")[0] +
            "</span>." +
            price_per_unit.split(".")[1];
          $(this)
            .parent()
            .parent()
            .find("#pricePerUnit")
            .html(formatted_price_per_unit);
          $(this).parent().find("#final-price-sqft").html(formatted_price);

          $(this)
            .parent()
            .find(".sq-ft-cover")
            .text("Covers " + sqft + " sq. ft.");
        } else {
          $(this)
            .parent()
            .parent()
            .find(".price-item.price-item--sale.price-item--last")
            .text(regular_price);
        }

        $(".sqft-in-popup").text(sqft);
        if (sample_id === "") {
          //  if ($('.paint-custom-color').length == 0 || $('.paint-custom-color').val() != 'none') {
          //    $('#sample-ProductSubmitButton1').removeAttr('disabled','disabled');
          //    $('#sample-ProductSubmitButton').removeAttr('disabled','disabled');
          // }
        } else {
          // $('#sample-ProductSubmitButton1').removeAttr('disabled','disabled');
          // $('#sample-ProductSubmitButton').removeAttr('disabled','disabled');
        }

        $("#sample-ProductSubmitButton1")
          .parent()
          .find('input[name="id"]')
          .attr("value", sample_id);
        $("#sample-ProductSubmitButton")
          .parent()
          .find('input[name="id"]')
          .attr("value", sample_id);
        $(this).parent().parent().find(".selected-color").text(selectedColor);
        // console.log('my save price is ' + save_price);
        if (parseFloat(save_price) > 0) {
          $(".sale-price-small").removeClass("visibility-hidden");
          $(this)
            .parent()
            .find(".without-sale-price")
            .removeClass("visibility-hidden");
          $(this).parent().find(".save_price").removeClass("visibility-hidden");
          $(this)
            .parent()
            .find(".without-sale-price")
            .html("Was: <span>$" + was_price + "</span>");
          $(this)
            .parent()
            .find(".save_price")
            .text("Save: $" + save_price);
        } else {
          $(this)
            .parent()
            .find(".without-sale-price")
            .addClass("visibility-hidden");
          $(this).parent().find(".save_price").addClass("visibility-hidden");
        }
        $(this)
          .parent()
          .parent()
          .find(".product__sku")
          .html('<span class="visually-hidden">Item:</span> ' + variant_sku);
        if (
          variant_model === null ||
          variant_model === undefined ||
          variant_model === ""
        ) {
          $(".model-id").html("");
        } else {
          $(this)
            .parent()
            .parent()
            .find(".model-id")
            .html("<span>Model</span> #" + variant_model);
          $(".model-id").removeClass("visibility-hidden");
        }
        if (
          variant_sku === null ||
          variant_sku === undefined ||
          variant_sku === "Item #"
        ) {
          // console.log('no sku');
          $(this).parent().parent().find(".product__sku").hide();
        } else {
          // console.log('my sku '+variant_sku+' is trying to be unhidden');
          $(this)
            .parent()
            .parent()
            .find(".product__sku")
            .removeClass("visibility-hidden");
        }

        $(".big-price-container").removeClass("visibility-hidden");
        $(".sale-price-small.visibility-hidden").removeClass(
          "visibility-hidden"
        );
      }
      // anytime the color changes we just recalculate the quantity instead of chasing ghosts (and if they change panel to square or square to panel, then we want to make sure this is reflected in their quantity
    });

    if (
      template.includes("Boxed Flooring") ||
      template.includes("Sheet Flooring")
    ) {
      console.log("calculateAndUpdateFloorSizing");
      calculateAndUpdateFloorSizing();
    }

    $('input[name="page[title]"]').val($("h1").text());
    $('input[name="page[href]"]').val(combined_options);
    $(".main-product-card_for_accessory-products")
      .find(".accessory-card__options-display")
      .html(" - " + combined_options);
    console.log('combined options '+combined_options);

    // shipping/backorder/sale messages

    $(".pro-free-shipping").each(function () {
      $(this).addClass("special-message");
      if ($(this).attr("for") == selectedVariant) {
        $(this).removeClass("special-message");
      }
    });

    $(".pro-backorder-text").each(function () {
      $(this).addClass("special-message");
      if ($(this).attr("for") == selectedVariant) {
        $(this).removeClass("special-message");
        if ($(this).attr("allow-purchase") == "false") {
          $(".button--primary").attr("disabled", "disabled");
          $(".button--primary > span").text("Not Available");
        }
      }
    });

    $(".sale-info-msg").each(function () {
      $(this).addClass("special-message");
      if ($(this).attr("for") == selectedVariant) {
        $(this).removeClass("special-message");
      }
    });

    $(".variant-id_for_accessory-products").val(selectedVariant);
    // update roomvo button
    $(".roomvo-button").attr(
      "href",
      "javascript: roomvo.startStandaloneVisualizer('','" +
        selected_variant_sku +
        "');"
    );

    if ($("#on-sale-variants").text().indexOf(selectedVariant) > -1) {
      $(".product__media-item").find(".badge").removeClass("hide-badge");
      $('[data-sku*="' + selectedVariant + '"][variant-featured="true"]')
        .find(".badge")
        .removeClass("hide-badge");
    } else {
      $(".product__media-item").find(".badge").addClass("hide-badge");
      $('[data-sku*="' + selectedVariant + '"][variant-featured="true"]')
        .find(".badge")
        .addClass("hide-badge");
    }

    // checkSale();

    //so the subtotal for the accessory products get updated
    // $(".add-to-cart_checkbox").trigger("change");
    $('.quantity__input[name="quantity"]').trigger("change");
  });

  //trigger an initial change event on page load to trigger all the above
  $(".selected-product-variant").trigger("change");

  // for accessory product list on product page
  $(".add-to-cart_checkbox").change(function (e) {
    const checkedProducts = $(".add-to-cart_checkbox:checked");
    var subtotal = 0;
    checkedProducts.each(function () {
      subtotal += parseFloat(
        $(this).closest(".card").find(".now-price").text().substring(1)
      );
    });

    const subtotalParts = subtotal.toFixed(2).split(".");
    $("#accessory-products_final-price").html(
      '$<span class="whole-number">' +
        subtotalParts[0] +
        "</span>." +
        subtotalParts[1]
    );

    const numProductsChecked = $(".add-to-cart_checkbox:checked").length;
    $(".accessory-btn-txt").html(
      "Add " + numProductsChecked + " Products to Cart"
    );
    if (this.checked) {
      $(this).siblings('input[type="hidden"]').removeAttr("disabled");
    } else {
      $(this).siblings('input[type="hidden"]').attr("disabled", "disabled");
    }
  });

  // ------------------------------------- ON CHANGE QUANTITY -----------------------------------------------------

  //update prices on the accessory products list
  $('.quantity__input[name="quantity"]').on('change',function() {
    var quantity = parseInt($(this).val().replace(',',''));
    $('.accessory__quantity-input0').val(quantity);
    $(".main-product-card_for_accessory-products").find('.accessory-card__quantity-display').html(' Quantity: '+quantity);
    $('.accessory-card__quantity-display[sf-per-box]').each(function() {
      const mainProduct_sqft = parseInt($('#sqft_input').val().replace(',',''));
      const sf_per_box = $(this).attr('sf-per-box');
      var quantity = Math.ceil(mainProduct_sqft / sf_per_box);
      $(this).html(' Quantity: '+quantity);
      const this_card = $(this).closest('.card');
      this_card.find('.accessory__quantity-input').val(quantity);
      const this_price = this_card.find('.pricing-list').attr('variant-price');
  
      var split_price = this_price.split("$")[1];
      var recalculated_price = split_price * quantity;
      recalculated_price = recalculated_price.toFixed(2).toString();
      var formatted_price =
        "$<span class='whole-number'>" +
        recalculated_price.split(".")[0] +
        "</span>." +
        recalculated_price.split(".")[1];
      this_card
        .find(".now-price")
        .html(formatted_price);
    })
    const variant_id = $('.selected-product-variant').val();
    const variant = $('.pricing-list[variant-id="'+variant_id+'"]');
    const regular_price = variant.attr('variant-price');

    var split_price = regular_price.split("$")[1];
    var recalculated_price = split_price * quantity;
    recalculated_price = recalculated_price.toFixed(2).toString();
    var formatted_price =
      "$<span class='whole-number'>" +
      recalculated_price.split(".")[0] +
      "</span>." +
      recalculated_price.split(".")[1];
    $(".main-product-card_for_accessory-products")
      .find(".now-price")
      .html(formatted_price);

    const checkedProducts = $(".add-to-cart_checkbox:checked");
    var subtotal = 0;
    checkedProducts.each(function () {
      subtotal += parseFloat(
        $(this).closest(".card").find(".now-price").text().substring(1)
      );
    });

    const subtotalParts = subtotal.toFixed(2).split(".");
    $("#accessory-products_final-price").html(
      '$<span class="whole-number">' +
        subtotalParts[0] +
        "</span>." +
        subtotalParts[1]
    );

  });
  // --------------------------------- ENABLE/DISABLE VARIANT OPTIONS BASED ON AVAILABILITY------------------------------------

  $(".product-form__input input").change(function (e) {
    if ($(this).hasClass("disabled")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    $this = $(this);
    setTimeout(function () {
      // Get selected options for size and color
      var selectedSize = $('input[name="Size"]:checked').val();
      var selectedOption = $("fieldset[primary-option] input:checked").val();

      let selectedOptions = new Map();
      $("fieldset.product-form__input:not(.custom)").each(function (index) {
        selected = $(this).find("input:checked").val();
        selectedOptions.set(index, selected);
      });

      // console.log(selectedOptions);
      combinedSelectedOptions = [...selectedOptions.values()].join(" / ");

      //for each option field, make a dynamic combiation of each option value + the other current user-selected options
      //the .custom class is used for custom paint colors and the like, so ignore it
      $("fieldset.product-form__input:not(.custom)").each(function (index) {
        $(this)
          .find("input")
          .each(function () {
            combinedOptions = [];
            selectedOptions.forEach((v, k) => {
              if (index != k) {
                combinedOptions[k] = v;
              }
            });

            combinedOptions[index] = $(this).val();

            var dynamicCombinedOption = combinedOptions.join();
            // console.log('dynamicCombinedOption is ' +dynamicCombinedOption);
            var id = $(this).attr("id");
            var correlatedLabel = $('label[for="' + id + '"]');
            // Check if the dynamic combination exists in the list of all potential options
            if (
              $(".all-potential-options")
                .text()
                .indexOf(dynamicCombinedOption) === -1
            ) {
              // If not valid, disable this color option
              $(this).addClass("disabled");
              $(this).next("label").addClass("option-disabled");

              // add message "unavailable in [other selected options]"
              selectedOptionsValues = [...selectedOptions.values()];
              selectedOptionsValues.splice(index, 1);
              var unavailable =
                '<p class="red-unavail">Unavailable in ' +
                selectedOptionsValues.join(" and ") +
                "</p>";

              if (
                correlatedLabel.find(".popup_data").find(".red-unavail")
                  .length === 0
              ) {
                correlatedLabel
                  .find(".popup_data")
                  .find(".color_value_red")
                  .append(unavailable);
              } else {
                correlatedLabel
                  .find(".popup_data")
                  .find(".red-unavail")
                  .html(unavailable);
              }
            } else {
              // If valid, enable this color option
              $(this).removeClass("disabled");
              $(this).next("label").removeClass("option-disabled");
              //   console.log('trying to remove ' + correlatedLabel.find('.popup_data').find('.red-unavail').attr('class'));
              correlatedLabel.find(".popup_data").find(".red-unavail").remove();
            }
          });
      });
      //update the text/thumbnail of the "Specs for..." header
      var label = $('label[for="' + $this.attr("id") + '"]');
      if (label.find(".inner-color-image").length) {
        var bg = label.find(".inner-color-image").css("background-image");
        bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
        $(".f-30.m-0.mb-10 img").attr({ src: bg, srcset: bg });
      }
      $(".f-30.m-0.mb-10 span").text(combinedSelectedOptions);
    });
    // checkSale();
  });

  // Detect if the user is on a mobile device
  const isMobile = window.innerWidth <= 768; // Adjust the width threshold as needed
  // console.log('i am mobile ' + isMobile);
  if (!isMobile) {
    // Select all labels with the class "color-label"
    document.querySelectorAll(".color-label").forEach((label) => {
      let hideTimeout;

      // Show the popup when hovering over the label
      label.addEventListener("mouseenter", () => {
        const popup = label.querySelector(".popup_data");
        const radioInput = label.previousElementSibling; // Select the radio button above the label

        // Show the popup
        popup.style.display = "block";
        popup.style.opacity = "1";

        // remove the popup when mouse over the popup. so the popup doesn't get in the way when user moves the mouse to a color in the row above
        popup.addEventListener("mouseenter", () => {
          popup.style.display = "none";
          popup.style.opacity = "1";
        });

        // Clear any existing hide timeout if they re-hover
        clearTimeout(hideTimeout);

        // Set a timeout to hide the popup after 3 seconds
        hideTimeout = setTimeout(() => {
          popup.style.opacity = "0";
          setTimeout(() => {
            popup.style.display = "none";
          }, 300); // Wait for the opacity transition to finish
        }, 2000); // Hide after 3 seconds
      });

      // Hide the popup immediately when the user hovers out
      label.addEventListener("mouseleave", () => {
        const popup = label.querySelector(".popup_data");

        // Clear the timeout so it doesn’t hide after 3 seconds
        clearTimeout(hideTimeout);

        // Hide the popup immediately
        popup.style.opacity = "0";
        setTimeout(() => {
          popup.style.display = "none";
        }, 300); // Wait for the opacity transition to finish
      });
    });
  }

  var addToCartForm = document.getElementById("addToCartForm");
  var sampleProductSubmitButton = document.getElementById(
    "sample-ProductSubmitButton"
  );
  var sampleProductSubmitButton1 = document.getElementById(
    "sample-ProductSubmitButton1"
  );
  var accessoryProductSubmitButton = document.getElementById(
    "accessory-ProductSubmitButton"
  );

  function handleFormSubmission(event) {
    event.preventDefault();
    var formData = new FormData(event.currentTarget.form);

    // for (const value of formData) {
    //       console.log(value);
    //     }
    for (const p of formData.entries()) {
      console.log(p);
    }
    // Get the b elements inside both buttons
    var btnTextElements = [
      sampleProductSubmitButton.querySelector("b.sample-btn-txt"),
      sampleProductSubmitButton1.querySelector("b.sample-btn-txt"),
    ];

    // Change the text to indicate progress
    btnTextElements.forEach((btnTextElement) => {
      if (btnTextElement) {
        // btnTextElement.textContent = 'ADDING Sample to Cart';
      }
    });

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        console.log(response.json());
        if (response.ok) {
          // Change the text to indicate success
          //    console.log("response", response );
          btnTextElements.forEach((btnTextElement) => {
            if (btnTextElement) {
              // console.log("aa",btnTextElement.getAttribute('class'));
              // btnTextElement.textContent = 'Add Another Sample to Cart ';
            }
            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: {},
                sections: ["cart-drawer", "cart-icon-bubble"],
              }),
            })
              .then((res) => res.json())
              .then((cartData) => {
                document.querySelector("cart-drawer").renderContents(cartData);
                document
                  .querySelector("cart-drawer.drawer")
                  .classList.remove("is-empty");
              });
          });
        } else {
          // Change the text to indicate failure
          btnTextElements.forEach((btnTextElement) => {
            if (btnTextElement) {
              btnTextElement.textContent = "Failed to add";
            }
          });
          console.error("Failed to add product to cart:", response.statusText);
        }
      })
      .catch((error) => {
        // Change the text to indicate network error
        btnTextElements.forEach((btnTextElement) => {
          if (btnTextElement) {
            btnTextElement.textContent = "Network error";
          }
        });
        console.error("Network error:", error);
      });
  }

  if (
    addToCartForm &&
    sampleProductSubmitButton &&
    sampleProductSubmitButton1
  ) {
    sampleProductSubmitButton.addEventListener("click", handleFormSubmission);
    sampleProductSubmitButton1.addEventListener("click", handleFormSubmission);
    sampleProductSubmitButton.addEventListener(
      "touchstart",
      handleFormSubmission
    );
    sampleProductSubmitButton1.addEventListener(
      "touchstart",
      handleFormSubmission
    );
    sampleProductSubmitButton.form = document.getElementById("addToCartForm");
    sampleProductSubmitButton1.form = document.getElementById("addToCartForm");
  }

  if (accessoryProductSubmitButton) {
    accessoryProductSubmitButton.addEventListener(
      "click",
      handleFormSubmission
    );
    accessoryProductSubmitButton.form = document.getElementById(
      "addToCartAccessoryProducts"
    );
    formData = new FormData(accessoryProductSubmitButton.form);
  }

  // ------------------------------------------ FLOORING DIMENSIONS CALCULATIONS -----------------------------------------

  function parseFormattedNumber(str) {
    return parseFloat(str.replace(/[^\d.]/g, ""));
  }

  function formatInputWithCommas(input) {
    let value = input.value.replace(/,/g, ""); // Remove existing commas
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas
    input.value = value;
  }

  $("#sqft_input").on("input", function () {
    formatInputWithCommas(this);
  });
  $("#area_sqrt").on("input", function () {
    formatInputWithCommas(this);
  });

  function calculateValues(
    areaValue = -1,
    boxValue = -1,
    includeWaste = false
  ) {
    var selectedVariant = $(".selected-product-variant").attr("value");
    const box_size = $(
      '.pricing-list[variant-id="' + selectedVariant + '"]'
    ).attr("data-sq-ft");
    const sqftPerBox = $(
      '.pricing-list[variant-id="' + selectedVariant + '"]'
    ).attr("data-sq-ft");
    const width = $(".pricing-list[variant-id=" + selectedVariant + "]").attr(
      "variant-width"
    );

    let wasteMultiplier = includeWaste ? 1.1 : 1;
    if (isNaN(areaValue) || areaValue === "") {
      areaValue = 0;
    }

    let total_sqft = 0;
    if (boxValue > -1) {
      total_sqft = boxValue * box_size;
    } else if (areaValue > -1) {
      total_sqft = areaValue;
    }

    // console.log('total_sqft is '+total_sqft);

    total_sqft = total_sqft * wasteMultiplier;
    let total_box = Math.max(Math.ceil(total_sqft / box_size), 1);
    let box_sqft = total_box * box_size;
    let length = Math.round((total_box * (sqftPerBox * 144)) / width, 0);
    return {
      totalBox: total_box,
      totalSqft: box_sqft,
      width: width,
      length: length,
    };
  }

  $("#waste").change(function () {
    calculateAndUpdateFloorSizing();
  });

  function calculateAndUpdateFloorSizing() {
    let inputValue = parseFormattedNumber($("#sqft_input").val());
    let includeWaste = $("#waste").is(":checked");

    let { totalBox, totalSqft, width, length } = calculateValues(
      inputValue,
      -1,
      includeWaste
    );
    updateUI(totalBox, totalSqft, width, length);
  }

  function updateUI(totalBox, totalSqft, width = 0, length = 0) {
    totalSqft = parseFloat(totalSqft.toFixed(2));
    // console.log('totalSqft:'+totalSqft+ ', totalBox:'+totalBox);
    $(".sale-info .total-sqft").text(numberFormatter.format(totalSqft));
    $(".sale-info .total-boxcount").text(totalBox);
    $('.quantity__input[name="quantity"]').val(totalBox);
    $('.quantity__input[name="quantity"]').trigger("change");
    $(".sheet-flooring-width").text(width);
    $(".sheet-flooring-length").text(length);

    if (totalBox > 1) {
      $("quantity-input button.disabled").removeClass("disabled");
    }
  }

  function updateQuantityValue(change) {
    var selectedVariant = $(".selected-product-variant").attr("value");
    let currentValue = parseFormattedNumber(
      $('.quantity__input[name="quantity"]').val()
    );

    let newValue = currentValue + change;
    if (newValue < 1) {
      newValue = 1;
    }

    $('.quantity__input[name="quantity"]').val(currentValue);
    if (currentValue > 1) {
      $("quantity-input button.disabled").removeClass("disabled");
    }

    $('.quantity__input[name="quantity"]').trigger("input");

    let includeWaste1 = $("#waste").is(":checked") ? true : false;
  }

  $("#calculate").click(function () {
    coverage_estimator();
  });

  $("#west").change(function () {
    coverage_estimator();
  });

  $("#showEst").click(function () {
    $.fancybox.open({
      src: ".calculator-wrapper",
      type: "inline",
      opts: {},
    });
  });

  $('.quantity__button[name="minus"]').on("click", function () {
    updateQuantityValue(-1);
  });

  $('.quantity__button[name="plus"]').on("click", function () {
    updateQuantityValue(1);
  });

  $('.quantity__input[name="quantity"]').on("input", function () {
    var selectedVariant = $(".selected-product-variant").attr("value");
    let inputValue = parseFormattedNumber($(this).val());
    if (!isNaN(inputValue)) {
      let { totalBox, totalSqft, width, length } = calculateValues(
        -1,
        inputValue,
        false
      );
      $("#sqft_input").val(numberFormatter.format(totalSqft));
      updateUI(inputValue, totalSqft, width, length);
    }
  });

  $("#sqft_input").on("input", function () {
    let inputValue = parseFormattedNumber($(this).val());
    if (!isNaN(inputValue)) {
      let { totalBox, totalSqft, width, length } = calculateValues(
        inputValue,
        -1,
        $("#waste").is(":checked")
      );
      updateUI(totalBox, totalSqft, width, length);
    }
  });

  function coverage_estimator() {
    var selectedVariant = $(".selected-product-variant").attr("value");
    const areaValue = parseFormattedNumber($("#area_sqrt").val());
    const westValue = parseFormattedNumber($("#west option:selected").val());

    const box_size = $(
      '.pricing-list[variant-id="' + selectedVariant + '"]'
    ).attr("data-sq-ft");
    //  console.log('my box size is ' + box_size);

    let total_west = (areaValue * westValue) / 100;
    let total_sqft = total_west + areaValue;
    let total_box = Math.ceil(total_sqft / box_size);
    let box_sqft = Math.round(total_box * box_size);

    $(".total_sqft").html(numberFormatter.format(box_sqft));
    $(".boxes").html(total_box);

    if ($('.quantity__input[name="quantity"]').val() !== total_box.toString()) {
      $('.quantity__input[name="quantity"]').val(total_box);
      if (total_box > 1) {
        $("quantity-input button.disabled").removeClass("disabled");
      }
    }
    $("#sqft_input").val(numberFormatter.format(box_sqft));
    $(".sale-info .total-sqft").html(numberFormatter.format(box_sqft));
  }
  var WindowHeight = jQuery(window).height();

  var load_element = 0;

  //position of element
  var scroll_position = jQuery(".des-section.w-bg .tab-links").offset().top;

  var screen_height = jQuery(window).height();
  var activation_offset = 0;
  var max_scroll_height = jQuery("body").height() + screen_height;

  var scroll_activation_point =
    scroll_position - screen_height * activation_offset;
  // var tab1 = jQuery('#tabs-1').offset().top;
  // var tab2 = jQuery('#tabs-2').offset().top;
  // var tab3 = jQuery('#tabs-3').offset().top;
  // var tab4 = jQuery('#tabs-4').offset().top;
  jQuery(window).on("scroll", function (e) {
    // if(!$('body').hasClass("stop-sticky")){
    var y_scroll_pos = window.pageYOffset;
    var element_in_view = y_scroll_pos > scroll_activation_point;
    var has_reached_bottom_of_page =
      max_scroll_height <= y_scroll_pos && !element_in_view;

    // if(y_scroll_pos < tab1){
    //
    // jQuery('.active-tab').removeClass('active-tab');
    //  jQuery('#tabs-2').addClass('active-tab');
    //
    // } else if(y_scroll_pos < tab2){
    // jQuery('.active-tab').removeClass('active-tab');
    //  jQuery('#tabs-3').addClass('active-tab');
    //   }  else if(y_scroll_pos < tab3){
    //   jQuery('.active-tab').removeClass('active-tab');
    //    jQuery('#tabs-4').addClass('active-tab');
    //     }

    if (element_in_view || has_reached_bottom_of_page) {
      if (!jQuery(".des-section.w-bg .tab-links").hasClass("tab-sticky")) {
        jQuery(".des-section.w-bg .tab-links").addClass("tab-sticky");
        jQuery(".des-section.w-bg .tab-links").addClass(
          "tab-sticky-tab-active"
        );

        setTimeout(function () {
          let iid = jQuery(".tab-sticky li a.active").attr("href");
          if (iid != "" && iid !== undefined) {
            console.log(iid);
            iid = iid.replace("#", "");
            targetSectionid = document.getElementById(iid);
            if (jQuery("body").hasClass("clickontab")) {
              jQuery("html, body").animate({
                scrollTop:
                  targetSectionid.offsetTop -
                  document.querySelectorAll(".des-tab")[0].offsetHeight,
              });

              jQuery("body").removeClass("clickontab");
            }
          }
        }, 800);
      }
      // jQuery('.des-section.w-bg .tab-links').addClass("tab-sticky");
    } else {
      jQuery("body").removeClass("stop-sticky");
      jQuery(".des-section.w-bg .tab-links").removeClass("tab-sticky");
      jQuery(".des-section.w-bg .tab-links").removeClass(
        "tab-sticky-tab-active"
      );
    }
    // }
  });

  const tabs = document.querySelectorAll(".des-tab");
  const sections = document.querySelectorAll(".des-content");

  window.addEventListener("scroll", function () {
    if (!$("body").hasClass("stop-sticky")) {
      let fromTop = window.scrollY + 110;

      sections.forEach((section) => {
        if (
          section.offsetTop <= fromTop &&
          section.offsetTop + section.offsetHeight > fromTop
        ) {
          tabs.forEach((tab) => {
            if (tab.dataset.target === section.id) {
              tab.classList.add("active");
            } else {
              tab.classList.remove("active");
            }
          });
        }
      });
    }
  });

  tabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      jQuery("body").addClass("clickontab");

      document.querySelectorAll(".des-content").forEach((content) => {
        jQuery(content).removeClass("active");
      });

      const targetSection = document.getElementById(this.dataset.target);
      jQuery(targetSection).addClass("active");
      setTimeout(function () {
        jQuery("html, body").animate({
          scrollTop: targetSection.offsetTop - tabs[0].offsetHeight,
        });
      }, 200);

      tabs.forEach((t) => {
        jQuery(t).removeClass("active");
      });

      jQuery(this).addClass("active");
    });
  });

  // disable the order submit button if paint selected color is none
  $(".paint-custom-color").on("change", function () {
    var selection = $(this).val();
    if (selection == "none") {
      $(".button--primary").attr("disabled", "disabled");
      $(".button--primary > span").text("Select a color");
      $(".button--primary > b").text("Select a color");
    } else {
      $(".button--primary").removeAttr("disabled");
      $(".button--primary > span").text("Add to Cart");
      $(".button--primary > b").text("Add a Sample to Cart");
      if ($(".paint-custom-color").attr("sample") == "untinted") {
        $("#sample-ProductSubmitButton > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton1 > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton").removeAttr("disabled");
        $("#sample-ProductSubmitButton1").removeAttr("disabled");
      }
    }
  });

  $(".paint-custom-color-text").on("input", function () {
    var selection = $(this).val();
    if (selection == "") {
      $(".button--primary").attr("disabled", "disabled");
      $(".button--primary > span").text("Select a color");
      $(".button--primary > b").text("Select a color");
    } else {
      $(".paint-custom-color").val(selection);
      $(".button--primary").removeAttr("disabled");
      $(".button--primary > span").text("Add to Cart");
      $(".button--primary > b").text("Add a Sample to Cart");
      if ($(".paint-custom-color").attr("sample") == "untinted") {
        $("#sample-ProductSubmitButton > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton1 > b").text(
          "Add Untinted Sample to Cart"
        );
        $("#sample-ProductSubmitButton").removeAttr("disabled");
        $("#sample-ProductSubmitButton1").removeAttr("disabled");
      }
    }
  });

  
});
